const config = {
  API_BASE: process.env.REACT_APP_API_BASE,
  GOOGLE_MAPS_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY
};

export default config;
